// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Fdg","comment":"styles_comment__29ula"};